import Tooltip from './Outputs/Tooltip';
import Link from './Outputs/Link';
import Breadcrumbs from './Outputs/Breadcrumbs';

const Components = {
  Tooltip,
  Link,
  Breadcrumbs,
};
export { Tooltip, Link, Breadcrumbs, };
export default Components;
